import React from 'react';

type Props = {
  searchStatus: string | null;
  searchError?: string | null;
  calendarStatus: string | null;
  calendarError?: string | null;
};

const PeopleTravelAgentStatusBanner: React.FC<Props> = ({
  searchStatus,
  searchError,
  calendarStatus,
  calendarError,
}) => {
  const items: React.ReactNode[] = [];

  if (searchStatus === 'pending' || searchStatus === 'processing') {
    items.push(
      <div key="search" className="people-travel-agent-banner pending">
        Travel agent is searching for flights, hotels, and rental cars…
      </div>,
    );
  }
  if (searchStatus === 'failed' && searchError) {
    items.push(
      <div key="search-fail" className="people-travel-agent-banner failed">
        Travel search failed: {searchError}
      </div>,
    );
  }
  if (calendarStatus === 'pending' || calendarStatus === 'processing') {
    items.push(
      <div key="cal" className="people-travel-agent-banner pending">
        Calendar Agent is placing trip events on the executive calendar…
      </div>,
    );
  }
  if (calendarStatus === 'failed' && calendarError) {
    items.push(
      <div key="cal-fail" className="people-travel-agent-banner failed">
        Calendar sync failed: {calendarError}
      </div>,
    );
  }

  if (items.length === 0) return null;
  return <>{items}</>;
};

export default PeopleTravelAgentStatusBanner;
